exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-5bfd654a]{padding:0}.icon-close[data-v-5bfd654a]{position:absolute;right:5px;top:5px;font-size:36px}.modal-title[data-v-5bfd654a]{word-spacing:100vw}\n", ""]);

// exports
